import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

const projectId = import.meta.env.VITE_SANITY_PROJECT_ID;

export const sanityClient = projectId
    ? createClient({
        projectId,
        dataset: import.meta.env.VITE_SANITY_DATASET || 'production',
        apiVersion: '2023-05-03',
        useCdn: false,
        token: import.meta.env.VITE_SANITY_API_TOKEN,
    })
    : null;

let builder: any = null;
try {
    if (sanityClient) builder = imageUrlBuilder(sanityClient);
} catch (e) {
    console.error('Sanity builder init failed', e);
}

export function urlFor(source: any) {
    if (!builder || !source) return { url: () => '' };
    return builder.image(source);
}
